import { render, staticRenderFns } from "./ListagemRequisicao.vue?vue&type=template&id=58d72823&"
import script from "./ListagemRequisicao.vue?vue&type=script&lang=js&"
export * from "./ListagemRequisicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports